import type { FeatureFlags } from '#core/server/types/featureFlags'
import type { LDClient, LDContext } from 'launchdarkly-js-client-sdk'

/**
 * Retrieves the details of feature flags that are currently in experiment.
 * @param featureFlags fetched feature flags.
 * @param context Context for fetching details.
 * @param client LDClient instance.
 * @returns Feature flags that are in experiment and information on active variant.
 * @category Utils
 */
export const getExperiments = (featureFlags: FeatureFlags, context: LDContext, client: LDClient,) => {
  const experiments: Partial<{ [key in keyof FeatureFlags]: any }> = {}

  try {
    Object.entries(featureFlags)
      .forEach(([key]) => {
        // exclude entries that can't be an experiment
        if (key.startsWith('$') || key === 'localFlags') return
        const variationDetail = client.variationDetail(key, context)
        if (variationDetail.reason?.inExperiment) experiments[key] = variationDetail.value
      })
  }
  catch (err: any) {
    log.error('[Canvas:LD] Experiments could not be fetched', err)
  }

  return experiments
}
